/**
 * TK-31 (v2026_r2) — thanh tab của trang tủ: "Tủ" · "Đèn NEMA".
 *
 * ⛔ CHỈ dựng khi máy chủ bật NEMA (`useNemaBat().trangThai === 'bat'`). Cờ tắt ⇒ trang tủ KHÔNG có
 *   phần tử nào của thanh này — DOM y như beta (mốc 1).
 * Tab đang chọn sống trong URL (`?tab=nema`) để Bản đồ / Tổng quan dẫn thẳng tới tab Đèn NEMA.
 */
export type TabTu = 'tu' | 'nema';

export function ThanhTabNema({ dangChon, onChon }: { dangChon: TabTu; onChon: (t: TabTu) => void }) {
  const muc: { khoa: TabTu; nhan: string }[] = [
    { khoa: 'tu', nhan: 'Tủ' },
    { khoa: 'nema', nhan: 'Đèn' },
  ];
  return (
    <div role="tablist" aria-label="Trang tủ" className="flex gap-1 border-b border-vien" data-o="thanh-tab-nema">
      {muc.map((m) => {
        const chon = m.khoa === dangChon;
        return (
          <button
            key={m.khoa}
            type="button"
            role="tab"
            aria-selected={chon}
            data-tab={m.khoa}
            onClick={() => onChon(m.khoa)}
            className={
              '-mb-px border-b-2 px-3 py-1.5 text-sm ' +
              (chon ? 'border-nhan font-semibold text-chu-1' : 'border-transparent text-chu-2 hover:text-chu-1')
            }
          >
            {m.nhan}
          </button>
        );
      })}
    </div>
  );
}
